// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"358":"e3a9c475","513":"e1e87341","533":"2bdb7a85","662":"08d2c600"}[chunkId] + ".chunk.css";
};